import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Header from '../components/header/Header';
import Footer from '../components/common/footer/Footer';
import Announcement from '../components/announcement/Announcement';
var MainLayout = function (props) {
    var classes = useStyles();
    var theme = useTheme();
    return (React.createElement("main", { className: classes.content },
        React.createElement(Header, { isMainLayout: true }),
        React.createElement(Announcement, null),
        React.createElement("div", { className: classes.wrapper }, props.children),
        React.createElement(Footer, null)));
};
var useStyles = makeStyles(function (theme) { return ({
    content: {
        flexGrow: 1,
        paddingTop: 48,
        height: '90%'
    },
    wrapper: {
        display: 'table',
        width: '100%',
        tableLayout: 'fixed',
        overflow: 'auto',
        height: '100%',
        position: 'relative'
    }
}); });
export default MainLayout;
